import firebase from "firebase";
import { OlabItem } from "./olabitem.js";
// import { OlabUtils } from "./olabutils.js";

class OlabProject extends OlabItem {
  static getCreateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          olab_id: item.olab_id,
          olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          creator: item.creator,
          creator_uc: item.creator_uc,
          desc: item.desc,
          start_date: item.start_date,
          end_date: item.end_date,
          created_date: firebase.firestore.FieldValue.serverTimestamp(),
          // cart_count should only be created and initialized
          // once. Do not update or change this value at project edit.
          cart_count: 0
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }

  static getUpdateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          // olab_id: item.olab_id,
          // olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          creator: item.creator,
          creator_uc: item.creator_uc,
          desc: item.desc,
          start_date: item.start_date,
          end_date: item.end_date,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }
}

export { OlabProject };
